import { Component } from 'react';

import _ from 'lodash';
import { FormattedMessage } from 'react-intl';

import { SelectWithSearch } from '../selectWithSearch';
import styles from './AutoCompany.module.css';

class AutoCompany extends Component {
    handleOnChange = (value) => {
        this.props.onChange(value);
        this.props.fetchCompanies(value);
    };

    getSelectedLabel = () => {
        const { companyName } = this.props;

        if (_.get(companyName, 'input')) {
            return `${companyName.input.value}`;
        }
    };

    renderNoResults() {
        return (
            <div className={styles.noResults}>
                <span className={styles.title}>
                    <FormattedMessage
                        id="_.auto_company.company_not_found_error_title"
                        defaultMessage="Oops. We couldn't find your company"
                    />
                </span>

                <span className={styles.content}>
                    <FormattedMessage
                        id="_.auto_company.company_not_found_error_content"
                        defaultMessage="Are you sure you have entered your registered company name? If you still can't find your company then"
                    />
                </span>
            </div>
        );
    }

    renderNoSearchTerm() {
        return (
            <div className={styles.noSearchTerm}>
                <div className={styles.title}>
                    <FormattedMessage
                        id="_.auto_company.search_for_company"
                        defaultMessage="Search for your company"
                    />
                </div>
                <div className={styles.content}>
                    <FormattedMessage
                        id="_.auto_company.no_search_term_content"
                        defaultMessage="Enter your full company name, as registered with Companies House"
                    />
                </div>
            </div>
        );
    }

    renderLocalisedLabel() {
        return (
            <FormattedMessage
                id="_.auto_company.registered_company_name"
                defaultMessage="Registered name"
            />
        );
    }

    buildCompanyLabel(company) {
        return `${company.name} (${company.number})`;
    }

    onSelect = (item) => {
        const { companies, companyName, companyNumber, onChangePrompt } =
            this.props;
        let selectedCompany;

        if (item) {
            selectedCompany = _.find(companies, {
                number: item.value
            });
        }

        if (selectedCompany) {
            if (companyName && companyNumber) {
                companyName.input.onChange(selectedCompany.name);
                companyNumber.input.onChange(selectedCompany.number);
                onChangePrompt();
            }
        }
    };

    renderCompanies = () => {
        const { companies } = this.props;

        if (!companies) {
            return [];
        }

        return _.map(companies, (company) => {
            return {
                label: `${this.buildCompanyLabel(company)}`,
                value: company.number
            };
        });
    };

    render() {
        const {
            companies,
            fetchCompaniesPending,
            toggleManualCompanyState,
            companyName
        } = this.props;

        const label = this.renderLocalisedLabel();
        const value = _.get(companyName, 'input.value') || null;

        return (
            <>
                <label className={styles.label}>{label}</label>
                <SelectWithSearch
                    className={styles.AutoCompany}
                    value={value}
                    onChange={this.handleOnChange}
                    onBlur={this.handleOnChange}
                    onButtonClick={this.handleOnChange}
                    items={this.renderCompanies()}
                    isSuccess={companies}
                    isLoading={fetchCompaniesPending}
                    onSelect={this.onSelect}
                    manualSwitchText={
                        <FormattedMessage
                            id="_.auto_company.choose_company_link_text"
                            defaultMessage="enter manually)"
                        />
                    }
                    noResultsRenderer={this.renderNoResults}
                    noSearchTermRenderer={this.renderNoSearchTerm}
                    warningRenderer={this.warningRenderer}
                    manualSwitch={toggleManualCompanyState}
                    selectedLabel={this.getSelectedLabel()}
                    helperText={
                        <FormattedMessage
                            id="_.auto_company.choose_company_helper_text"
                            defaultMessage="Choose your company (or"
                        />
                    }
                    switchPosition={'top'}
                    placeholder={'Search...'}
                />
                <div className={styles.toggleManualCompany}>
                    <FormattedMessage
                        id="_.auto_company.cant_find_company"
                        defaultMessage="Can't find the company?"
                    />{' '}
                    <span
                        data-testid="manualCompanyToggleLink"
                        className={styles.manualCompanyToggleLink}
                        onClick={toggleManualCompanyState}
                    >
                        <FormattedMessage
                            id="_.auto_company.enter_manually"
                            defaultMessage="Enter it manually"
                        />
                    </span>
                </div>
            </>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default AutoCompany;
